/**
 * Utility function to sort influencers in a specific order by name
 */

/**
 * Sort influencers according to a specific predefined order
 * @param {Array} influencers - Array of influencer objects
 * @returns {Array} - Sorted array of influencers
 */
export const sortInfluencersBySpecificOrder = (influencers) => {
  if (!influencers || !Array.isArray(influencers)) {
    return [];
  }

  // Define the specific order by name
  const specificOrder = [
    'Donut',
    'Throtl',
    'Humble Mechanic', 
    'Gator',
    'Make Everything'
  ];

  // Create a copy to avoid mutating the original array
  return [...influencers].sort((a, b) => {
    const nameA = a.title || '';
    const nameB = b.title || '';
    
    // Get the position in the specific order array
    const indexA = specificOrder.findIndex(name => nameA.includes(name));
    const indexB = specificOrder.findIndex(name => nameB.includes(name));
    
    // If both names are in our specific order, sort by that order
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    // If only one name is in our specific order, prioritize it
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    // For names not in our specific order, sort alphabetically
    return nameA.localeCompare(nameB);
  });
};
